var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var fetchLogger = [];
export var FETCH_REQUEST_ID = "fetch_request_id";
export var HttpInterceptor = {
    init: function () {
        var originalFetch = window.fetch;
        window.fetch = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                var now, _a, url, request, response, foundRequest, clonedResponse, responseData, contentType, contentLength;
                var _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            now = performance.now();
                            _a = __read(args, 2), url = _a[0], request = _a[1];
                            return [4 /*yield*/, originalFetch.apply(this, args)];
                        case 1:
                            response = _d.sent();
                            if (url instanceof Request)
                                url = url.url;
                            if (url instanceof URL)
                                url = url.href;
                            foundRequest = HttpInterceptor.findRequestByUrlAndTime(url, now);
                            if (foundRequest == null) {
                                foundRequest = {
                                    url: url,
                                    request: {
                                        method: (request === null || request === void 0 ? void 0 : request.method) || "GET",
                                    },
                                    startTime: now,
                                    __type: "http",
                                };
                                HttpInterceptor.recordHTTPRequest(foundRequest);
                            }
                            clonedResponse = response.clone();
                            contentType = clonedResponse.headers.get("content-type");
                            if (!(contentType === null || contentType === void 0 ? void 0 : contentType.includes("application/json"))) return [3 /*break*/, 3];
                            return [4 /*yield*/, clonedResponse.json()];
                        case 2:
                            responseData = _d.sent();
                            return [3 /*break*/, 5];
                        case 3: return [4 /*yield*/, clonedResponse.text()];
                        case 4:
                            responseData = _d.sent();
                            _d.label = 5;
                        case 5:
                            if (foundRequest.response == null) {
                                foundRequest.response = {
                                    contentLength: 0,
                                    data: null,
                                    status: 0,
                                    statusText: "",
                                };
                            }
                            foundRequest.response.status = clonedResponse.status || ((_b = foundRequest.response) === null || _b === void 0 ? void 0 : _b.status) || 0;
                            foundRequest.response.statusText = clonedResponse.statusText || ((_c = foundRequest.response) === null || _c === void 0 ? void 0 : _c.statusText) || "ok";
                            foundRequest.response.data = typeof responseData === "object" ? responseData : null;
                            contentLength = clonedResponse.headers.get("content-length") || "0";
                            foundRequest.response.contentLength = Number.parseInt(contentLength);
                            return [2 /*return*/, response];
                    }
                });
            });
        };
    },
    findRequestByUrlAndTime: function (url, startTime) {
        var formattedUrl = new URL(url);
        return fetchLogger.find(function (log) {
            if (formattedUrl.searchParams.has(FETCH_REQUEST_ID)) {
                return url === log.url;
            }
            if (url !== log.url)
                return false;
            return Math.abs(startTime - log.startTime) <= 10;
        });
    },
    recordGraphQLRequest: function (request) {
        fetchLogger.push(request);
    },
    recordHTTPRequest: function (request) {
        fetchLogger.push(request);
    },
    generateRequestId: function () {
        return Math.random().toString(36).substring(2) + Date.now().toString(36);
    },
    getLogs: function () {
        return fetchLogger;
    },
};
//# sourceMappingURL=http.interceptor.js.map